import React from "react";
import { RaisedButton, TextField, Checkbox } from "material-ui";
import moment from "moment";
import { Link } from "react-router";

import config from "../config";

import AccountTable from "./partials/account-table.jsx";
import ConnectWithStripe from "./partials/connect-with-stripe.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import UserActions from "../actions/UserActions";
import UserStore from "../stores/UserStore";
import UserUtil from "../utils/UserUtil";

import CreditCardEntry from "./partials/credit-card-entry.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

import LinkLike from "./partials/link-like.jsx";

class Organization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetched: false,
      isFetching: false,
      isEditingBilling: false,
      isSubmittingBilling: false,
      billingErrorMessage: null,
      ssoDomain: "",
      ssoConfig: {}
    };

    this.submitBilling = this.submitBilling.bind(this);
    this.submitSso = this.submitSso.bind(this);
  }

  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores() {
    return UserStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      section: {
        marginTop: 30
      },
      connectionsGrid: {
        display: "flex",
        flexDirection: "row",
        marginBottom: -10,
        marginRight: -10,
        marginLeft: -10,
        flexWrap: "wrap"
      },
      connection: {
        flexGrow: 1,
        margin: 10,
        width: 400,
        boxSizing: "border-box",
        boxShadow: "0 0 9px 3px rgba(0,0,0,0.1)",
        padding: 15,
        borderRadius: 10,
        textAlign: "center",
        display: "flex",
        flexDirection: "column"
      },
      connectionHeader: {
        marginBottom: 0
      },
      connectionDetail: {
        margin: "8px auto 16px",
        flex: 1,
        display: "flex",
        alignItems: "center",
        maxWidth: 450
      },
      disabledButton: {
        opacity: 0.5,
        pointerEvents: "none"
      },
      error: {
        color: "red",
        margin: "5px 0"
      },
      connectedLabel: {
        color: "#fff",
        padding: "2px 5px",
        fontSize: "0.75em"
      }
    };
  }

  submitBilling() {
    this.setState({
      isSubmittingBilling: true
    });
    Stripe.card.createToken(
      this.refs.cardEntry.getPaymentDetails(),
      (status, response) => {
        if (response.error) {
          this.setState({
            isSubmittingBilling: false,
            billingErrorMessage: response.error.message
          });
        } else {
          UserActions.editUser({
            payments_token: response.id
          });
        }
      }
    );
  }

  submitSso() {
    this.setState({
      isSubmittingSso: true
    });
    UserActions.editUser({
      sso_domain: this.state.ssoDomain,
      sso_config: this.state.ssoConfig
    });
  }

  activateVirtual() {
    UserUtil.generateVirtualActivationLink({
      apiKey: UserStore.getState().apiKey
    }).then(({ url }) => {
      window.location.href = `${url}&next=${encodeURIComponent(
        window.location.href
      )}`;
    });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);

    if (!document.getElementById("plaid-loader")) {
      const script = document.createElement("script");
      script.id = "plaid-loader";
      script.onload = () => {
        this._initializePlaid();
      };
      script.src = "https://cdn.plaid.com/link/v2/stable/link-initialize.js";
      document.head.appendChild(script); //or something of the likes
    } else {
      this._initializePlaid();
    }
  }

  _initializePlaid() {
    const linkHandler = Plaid.create({
      env: "production",
      clientName: "Eventive",
      key: "ea2fa373b010fffcbf72172db21460",
      product: ["auth"],
      selectAccount: true,
      onSuccess: (public_token, metadata) => {
        this.setState({ isSubmittingBilling: true });
        UserActions.editUser({
          bank_account_public_token: public_token,
          bank_account_id: metadata.account_id
        });
      },
      onExit: (err, metadata) => {}
    });
    this.setState({ plaidLinkHandler: linkHandler });
  }

  componentWillReceiveProps(newProps) {
    let { user } = newProps;

    if (!this.state.isFetching && !this.state.fetched) {
      UserActions.fetchUser();
      UserActions.fetchAccounts();
      UserActions.fetchRoles();
      this.setState({ isFetching: true });
    } else if (user) {
      this.setState({
        isFetching: false,
        fetched: true,
        isEditingBilling: false,
        isSubmittingBilling: false,
        isSubmittingSso: false,
        billingErrorMessage: null,
        ssoConfig: user.sso_config || {},
        ssoDomain: user.sso_domain
      });
      if (
        this.stripe &&
        !this.state.hasScrolledStripe &&
        window.location.hash === "#stripe"
      ) {
        this.stripe.scrollIntoView();
        this.setState({ hasScrolledStripe: true });
      }
    }
  }

  _makeStatus(label) {
    const styles = this.getStyles();
    return typeof label === "string" ? (
      <span
        style={Object.assign({}, styles.connectedLabel, {
          backgroundColor: "#0086D4"
        })}
      >
        {label}
      </span>
    ) : label ? (
      <span
        style={Object.assign({}, styles.connectedLabel, {
          backgroundColor: "#4CAF50"
        })}
      >
        Connected
      </span>
    ) : (
      <span
        style={Object.assign({}, styles.connectedLabel, {
          backgroundColor: "#F44336"
        })}
      >
        Not connected
      </span>
    );
  }

  addBankAccount() {}

  render() {
    let styles = this.getStyles();

    if (!this.props.user) {
      return <WorkingIndicator fullPage={true} />;
    }

    let { data, user, accounts, roles, apiKey } = this.props;

    if (user.type === "content_creator") {
      return (
        <div>
          <h1>{user.organization}</h1>
          <div style={styles.section}>
            <h2>Accounts</h2>
            <AccountTable
              accounts={accounts}
              roles={roles}
              selfAccountId={data.id}
              onSelfEdit={() => this.context.router.push("/account")}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        <h1>{user.organization}</h1>
        <div style={styles.section}>
          <h2>Accounts</h2>
          <AccountTable
            accounts={accounts}
            roles={roles}
            selfAccountId={data.id}
            onSelfEdit={() => this.context.router.push("/account")}
          />
        </div>
        <div style={styles.section}>
          <h2>Connections</h2>
          <div style={styles.connectionsGrid}>
            <div style={styles.connection}>
              <h3
                ref={r => {
                  this.stripe = r;
                }}
                style={styles.connectionHeader}
              >
                Stripe {this._makeStatus(user.connections.stripe)}
              </h3>
              <div style={styles.connectionDetail}>
                <div>
                  Eventive uses{" "}
                  <a href="https://stripe.com" target="_blank">
                    Stripe
                  </a>{" "}
                  to securely process payments.{" "}
                  {user.connections.stripe
                    ? "Your organization has connected with Stripe and is ready to accept credit card payments."
                    : "You must connect with Stripe in order to accept credit card payments."}{" "}
                  <a
                    target="_blank"
                    href="https://help.eventive.org/getting-started/connect-your-bank-account"
                  >
                    Learn&nbsp;more.
                  </a>
                </div>
              </div>
              <div>
                <ConnectWithStripe
                  href={
                    config.endpoint +
                    `auth/stripe?${UserStore.makeApiKeyQueryString()}&redirect=${encodeURIComponent(
                      window.location.href
                    )}`
                  }
                  style={user.connections.stripe ? styles.disabledButton : null}
                  connected={!!user.connections.stripe}
                />
              </div>
            </div>
            <div style={styles.connection}>
              <h3>MailChimp {this._makeStatus(user.connections.mailchimp)}</h3>
              <div style={styles.connectionDetail}>
                <div>
                  Connect with{" "}
                  <a href="https://mailchimp.com" target="_blank">
                    MailChimp
                  </a>{" "}
                  for automatic mailing list synchronization using{" "}
                  <a
                    target="_blank"
                    href="https://help.eventive.org/integrations/create-external-syncs"
                  >
                    Eventive external&nbsp;syncs
                  </a>
                  .
                </div>
              </div>
              <div>
                <RaisedButton
                  disabled={user.connections.mailchimp}
                  href={
                    config.endpoint +
                    `auth/mailchimp?${UserStore.makeApiKeyQueryString()}&redirect=${encodeURIComponent(
                      window.location.href
                    )}`
                  }
                  label={
                    <span>
                      {!user.connections.mailchimp ? "Connect with " : ""}
                      <img
                        src="https://storage.googleapis.com/eventive-co/mailchimp-logo.svg"
                        style={{
                          width: 93,
                          verticalAlign: -10,
                          opacity: user.connections.mailchimp ? 0.5 : 1
                        }}
                      />
                      {user.connections.mailchimp ? " connected" : ""}
                    </span>
                  }
                />
              </div>
            </div>
            <div style={styles.connection}>
              <h3>Eventival {this._makeStatus(user.connections.eventival)}</h3>
              <div style={styles.connectionDetail}>
                <div>
                  Connect with{" "}
                  <a href="https://eventival.com" target="_blank">
                    Eventival
                  </a>{" "}
                  to automatically sync films, events, and/or passes from your
                  Eventival database using{" "}
                  <a
                    target="_blank"
                    href="https://help.eventive.org/integrations/create-external-syncs"
                  >
                    Eventive external&nbsp;syncs
                  </a>
                  .
                </div>
              </div>
              <div>
                <RaisedButton
                  disabled={user.connections.eventival}
                  onClick={() =>
                    Intercom(
                      "showNewMessage",
                      "I'm ready to connect my Eventival account. My Eventival organization name is: "
                    )
                  }
                  label={
                    <span>
                      {!user.connections.eventival ? (
                        <span>Connect with&nbsp;&nbsp;</span>
                      ) : (
                        ""
                      )}
                      <img
                        src="https://storage.googleapis.com/eventive-co/eventival-dark.png"
                        style={{
                          width: 80,
                          verticalAlign: -1,
                          opacity: user.connections.eventival ? 0.5 : 1
                        }}
                      />
                      {user.connections.eventival ? (
                        <span>&nbsp;&nbsp;connected</span>
                      ) : (
                        ""
                      )}
                    </span>
                  }
                />
              </div>
            </div>
            <div style={styles.connection}>
              <h3>Zapier {/*this._makeStatus("Beta")*/}</h3>
              <div style={styles.connectionDetail}>
                <div>
                  Connect with{" "}
                  <a href="https://zapier.com" target="_blank">
                    Zapier
                  </a>{" "}
                  to instantly link Eventive to 1,500+ other apps, from
                  Airtable, to Instagram, to Salesforce, and everything in
                  between.
                  {/*<br />
                  <i>
                    This&nbsp;integration is in beta.{" "}
                    <LinkLike
                      onTouchTap={() =>
                        Intercom(
                          "showNewMessage",
                          "I'd like to get started with Zapier + Eventive: "
                        )
                      }
                    >
                      Contact us to get started.
                    </LinkLike>
                    </i>*/}
                </div>
              </div>
              <div>
                <RaisedButton
                  target="_blank"
                  href={
                    "https://zapier.com/developer/public-invite/19730/610b47a66a699a64812f1f8128c3f206/"
                  }
                  label={
                    <span>
                      Connect with{" "}
                      <img
                        src="https://storage.googleapis.com/eventive-co/zapier.svg"
                        style={{ width: 53, verticalAlign: -6, marginLeft: 2 }}
                      />
                    </span>
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div style={styles.section}>
          <h2>Eventive Virtual</h2>
          <div>
            Eventive Virtual is an annual add-on subscription to the Eventive
            platform.{" "}
            <a href="https://eventive.org/virtual" target="_blank">
              Learn more.
            </a>
          </div>
          {user.virtual_festival_plan_status === "active" ? (
            <div>
              <strong>Thanks!</strong> Your Eventive Virtual{" "}
              {user.virtual_festival_plan === "single_film"
                ? "Single Film"
                : user.virtual_festival_plan}{" "}
              subscription is active.{" "}
              <Link to="/billing">Manage subscription in the Billing Hub.</Link>
            </div>
          ) : (
            <div>
              <RaisedButton
                style={{ marginTop: 5 }}
                primary={true}
                label={"Activate Eventive Virtual"}
                onTouchTap={this.activateVirtual}
              />
            </div>
          )}
        </div>
        <div style={styles.section}>
          <h2>Single Sign-On (SSO)</h2>
          <div>
            Single Sign-On (SSO) is an optional add-on to the Eventive
            Dashboard. With SSO, your organization administrators can login
            securely to the Eventive Dashboard using credentials they already
            have, including AD, SAML, G Suite, and more.{" "}
            <a
              href="https://help.eventive.org/en/articles/4665490-eventive-dashboard-single-sign-on-sso"
              target="_blank"
            >
              Learn more.
            </a>
          </div>
          <div style={{ marginTop: 5 }}>
            Status:{" "}
            <strong>
              {user.sso_domain ? (
                `Enabled for ${user.sso_domain}`
              ) : (
                <span>
                  Not active &ndash;{" "}
                  <LinkLike
                    onTouchTap={() =>
                      Intercom(
                        "showNewMessage",
                        "I'd like to enable Single Sign-On for the Eventive Dashboard.\n\nDomain: << domain >>\nIdentity platform: << platform >>\nBilling: << monthly ($499/month) >> or << annual ($5499/year) >>\n\nThank you!"
                      )
                    }
                  >
                    Enable SSO
                  </LinkLike>
                </span>
              )}
            </strong>
          </div>
          {user.sso_domain || UserStore.isGod() ? (
            <div>
              <div>
                <TextField
                  style={{ marginBottom: 5, marginTop: -8 }}
                  disabled={!UserStore.isGod()}
                  floatingLabelText="SSO domain"
                  floatingLabelFixed={true}
                  placeholder="SSO not enabled"
                  title="Contact your Account Manager to change this domain."
                  value={this.state.ssoDomain}
                  onChange={e => {
                    this.setState({ ssoDomain: e.target.value });
                  }}
                />
              </div>
              <div style={{ maxWidth: 550 }}>
                <Checkbox
                  label="Upon login, create a new Eventive Dashboard account if one doesn't exist"
                  checked={this.state.ssoConfig.create_if_new}
                  onCheck={() => {
                    this.setState({
                      ssoConfig: {
                        ...this.state.ssoConfig,
                        create_if_new: !this.state.ssoConfig.create_if_new
                      }
                    });
                  }}
                />
              </div>
              <div style={{ maxWidth: 550 }}>
                <Checkbox
                  label="Only allow authentication using SSO (block username/password auth)"
                  checked={this.state.ssoConfig.sso_only}
                  onCheck={() => {
                    this.setState({
                      ssoConfig: {
                        ...this.state.ssoConfig,
                        sso_only: !this.state.ssoConfig.sso_only
                      }
                    });
                  }}
                />
              </div>
              <RaisedButton
                style={{ marginTop: 15 }}
                label={
                  this.state.isSubmittingSso
                    ? "Saving SSO settings..."
                    : "Save SSO settings"
                }
                disabled={this.state.isSubmittingSso}
                onClick={this.submitSso}
              />
            </div>
          ) : null}
        </div>
        {/*<div style={styles.section}>
          <h2>Payment methods</h2>
          <div>
            Some Eventive functionality is subject to additional fees. No
            charges will be performed without explicit authorization.
          </div>
          {this.state.isEditingBilling ? (
            <div>
              <CreditCardEntry
                style={{ maxWidth: 620, marginTop: -12, marginBottom: 12 }}
                ref="cardEntry"
              />
              {this.state.billingErrorMessage ? (
                <div style={styles.error}>{this.state.billingErrorMessage}</div>
              ) : null}
              <RaisedButton
                primary={true}
                label={
                  this.state.isSubmittingBilling
                    ? "Updating billing information"
                    : "Update billing information"
                }
                disabled={this.state.isSubmittingBilling}
                onTouchTap={this.submitBilling}
              />
              <RaisedButton
                style={{ marginLeft: 7 }}
                label="Cancel"
                onTouchTap={() => this.setState({ isEditingBilling: false })}
              />
            </div>
          ) : (
            <div>
              <div style={{ marginBottom: 10 }}>
                Current payment methods:{" "}
                <strong>
                  {user.bank_account_summary || "No bank account added"}{" "}
                  &middot;{" "}
                  {user.payment_method_summary || "No credit card added"}
                </strong>
              </div>
              <div>
                <RaisedButton
                  label={
                    this.state.isSubmittingBilling
                      ? "Adding bank account"
                      : "Add bank account"
                  }
                  onTouchTap={() => this.state.plaidLinkHandler.open()}
                  disabled={
                    !this.state.plaidLinkHandler ||
                    this.state.isSubmittingBilling
                  }
                />
                <RaisedButton
                  label="Add credit card"
                  style={{ marginLeft: 15 }}
                  onTouchTap={() => this.setState({ isEditingBilling: true })}
                />
              </div>
            </div>
          )}
        </div>*/}
      </div>
    );
  }
}

export default connectToStores(Organization);



// WEBPACK FOOTER //
// ./src/app/components/organization.jsx